import Call from '../Call.v3';

import qs from 'querystring';

const BidderClickUrlsHourly = {
    get(filters, group_by) {
        return Call(`wbidder/click_urls/hourly?${qs.stringify({ ...filters, group_by })}`);
    },
    distinct(field, filters) {
        return Call(`wbidder/click_urls/hourly/distinct/${field}?${qs.stringify(filters)}`)
    }
};

export default BidderClickUrlsHourly;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderClickUrlsHourly.js